import { getFirstAllowedMobilePath, canAccessMobilePath } from '@/utils/mobileAccess'

/** 主屏幕 / PWA 独立窗口 */
export function isStandalonePwaShell() {
  if (typeof window === 'undefined') return false
  try {
    if (window.matchMedia?.('(display-mode: standalone)')?.matches) return true
    if (window.matchMedia?.('(display-mode: minimal-ui)')?.matches) return true
    if (window.navigator.standalone === true) return true
    const q = new URLSearchParams(window.location.search || '')
    if (q.get('source') === 'pwa') return true
  } catch {
    /* ignore */
  }
  return false
}

/**
 * 客户端是否为「更像手机/平板浏览器」的环境（非服务端记录，可区分 UA / 触控 / 视口）。
 * 鸿蒙 / 请求桌面网站 的 iPhone 等：结合 maxTouchPoints、视口与指针特征判断。
 * 不做「偏好桌面版」豁免：手机浏览器一律只能走移动工作台路由，与权限模型一致。
 */

export function isLikelyMobileBrowser() {
  if (typeof window === 'undefined') return false

  // 桌面图标打开的独立窗口一律走移动工作台（避免落到桌面 Layout 看起来像白屏）
  if (isStandalonePwaShell()) return true

  try {
    const uaData = navigator.userAgentData
    if (uaData && typeof uaData.mobile === 'boolean' && uaData.mobile) {
      return true
    }
  } catch {
    /* ignore */
  }

  const ua = navigator.userAgent || ''

  // 显式终端 / WebView（鸿蒙等不一定包含 Android 字样）
  if (
    /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony|HMOS|ArkWeb|MicroMessenger|MQQBrowser|UCBrowser|SamsungBrowser|MiuiBrowser|HeyTapBrowser|VivoBrowser|Quark|HuaweiBrowser|HUAWEI|HMSCore|Mobile Safari|EdgA\/|EdgiOS\/|Silk\/|NokiaBrowser|SonyEricsson/i.test(
      ua
    )
  ) {
    return true
  }

  if (
    /\bMobile\b|\bXiaoMi\b| OPPO | vivo\/| vivo |Redmi|Realme|OnePlus|CoolPad|LeBrowser/i.test(ua)
  ) {
    return true
  }

  const iPadUa = /iPad/i.test(ua)
  const macTouch = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  /* iPadOS「桌面网站」常见宽屏，仍必须视为移动终端 */
  if (iPadUa || macTouch) {
    return true
  }

  try {
    const coarse = window.matchMedia('(pointer: coarse)').matches
    const noHover = window.matchMedia('(hover: none)').matches
    const w = window.innerWidth
    if (noHover && coarse && w <= 1280) return true
    if (coarse && w <= 900) return true
  } catch {
    /* ignore */
  }

  return false
}

/**
 * @param {unknown} redirectFromQuery 路由上的 redirect，可为 string | string[]
 * @param {object | null} [user] 已登录用户（与权限同步后），用于移动端首屏落到有权限的板块
 */
export function resolvePostLoginPath(redirectFromQuery, user = null) {
  const raw = Array.isArray(redirectFromQuery) ? redirectFromQuery[0] : redirectFromQuery
  const redirectStr = typeof raw === 'string' && raw.startsWith('/') ? raw : null

  if (isLikelyMobileBrowser()) {
    if (redirectStr && redirectStr.startsWith('/m') && user && canAccessMobilePath(redirectStr, user)) {
      return redirectStr
    }
    if (user) return getFirstAllowedMobilePath(user)
    return '/m'
  }

  if (redirectStr) return redirectStr
  return '/dashboard'
}
